module.exports = __webpack_public_path__ + "static/assets/663c93b7a3b945316908cd676bc6e34f.jpg";